import React from 'react';

import {renderRawDataPopoverContents} from 'analysis-tool/data-view/RawDataViewRegistry';
import {assertAndContinue} from 'Asserts';
import {PipelineStepRawData} from 'pipelines/PipelineTypes';
import Float from 'ui-library/floating-ui/Float';

import {DEFAULT_FLOAT_PROPS} from './PopoverConstants';

/**
 * Popover content to preview a raw step data (a data frame, a chart, a file, ...).
 *
 * The per-kind preview components live in the raw data view registry; this
 * delegates to it and degrades gracefully (renders nothing) for a kind without
 * registered popover content.
 */
export function RawDataPopoverContents({rawData}: {rawData: PipelineStepRawData}): JSX.Element {
  const contents = renderRawDataPopoverContents(rawData);
  if (contents == null) {
    assertAndContinue(false, 'No popover content for raw data kind', {typename: rawData.__typename});
    return <></>;
  }
  return contents;
}

interface RawStepDataPopoverProps {
  children: JSX.Element;
  rawData: PipelineStepRawData;
  disabled?: boolean;
}

/**
 * Show a popover to preview a raw step data (a data frame, a chart, a file, ...).
 */
export default function RawDataPopover({rawData, disabled, children}: RawStepDataPopoverProps): JSX.Element {
  return (
    <Float
      {...DEFAULT_FLOAT_PROPS}
      renderContent={() => <RawDataPopoverContents rawData={rawData} />}
      isDisabled={disabled}
    >
      {children}
    </Float>
  );
}
